<script lang="ts">
  import { onMount } from "svelte";
  import type { Props } from "./IconV1.types";
  import { useHost } from "../../../common/runtime/utils/useHost.ts";

  let { color = undefined, ocAriaLabel = undefined, type }: Props = $props();

  let Host = useHost();

  let animatedWishlistActiveHighlight = $state("");

  /**
 *
 *
 */
  const preloadAnimatedIcon = async (): Promise<void> => {
    if (animatedWishlistActiveHighlight) {
      return;
    }

    animatedWishlistActiveHighlight = (
      await import("./animatedSVG/animatedWishlistActiveHighlight.svg?raw")
    ).default;
  };

  onMount(() => {
    /*                                         */
    /*                                                     */
    if (type === "wishlist") {
      preloadAnimatedIcon();
    }
  });

  $effect(() => {
    /*                                                               */
    /*                                */
    if (type === "animated-wishlist-active-highlight") {
      /*                                                           */
      let current = true;

      /*                             */
      if (!animatedWishlistActiveHighlight) {
        preloadAnimatedIcon();
      }

      /*                                                        */
      if (current && animatedWishlistActiveHighlight) {
        Host.innerHTML = animatedWishlistActiveHighlight;
      }

      return () => (current = false);
    }
  });

  $effect(() => {
    if (color) {
      Host.style.setProperty("--color", color);
    } else if (Host.style.getPropertyValue("--color")) {
      Host.style.removeProperty("--color");
    }
  });

  /*                          */
  $effect(() => {
    if (ocAriaLabel) {
      Host.setAttribute("aria-label", ocAriaLabel);
      Host.role = "img";
    }
  });
</script>
